// extracted by mini-css-extract-plugin
module.exports = {"ImagesGrid":"ImagesGrid_ImagesGrid__yc__P","item":"ImagesGrid_item__hqHOL"};